import config from '../../../config.json'

export function SchemaMarkupLocalWebsite() {

    return <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: `{
            "@context" : "https://schema.org",
            "@type" : "WebSite",
            "name" : "${config.core.website_name}",
            "url" : "${config.core.rootUrl}"
}`}}>
    </script>
}